// Due versioni: "completa" (tutto il gestionale) e "semplice" (agenda, assistente IA, rubrica clienti).
export const SIMPLE_PATHS = ["/", "/agenda", "/contatti", "/assistente", "/impostazioni", "/attivita-oggi", "/posta", "/whatsapp", "/aziende", "/abbonamento"];

export const isSimple = (user) => user?.company?.edition === "semplice";

export const EDITIONS = [
  { key: "completa", title: "App completa", tag: "Tutto incluso",
    features: ["Preventivi, fatture e DDT", "Cantieri, operai, ore e spese", "Agenda, pagamenti e incassi", "Posta, WhatsApp e Assistente IA"] },
  { key: "semplice", title: "Gestionale semplice", tag: "Facile e veloce",
    features: ["Agenda completa: appuntamenti, promemoria e pagamenti", "Email e WhatsApp nell'app", "Assistente IA anche a voce + riepilogo ogni mattina", "Rubrica clienti"] },
];
